/**
 * Entrada do ATALAIA web. Duas aplicações no mesmo build:
 * - `/campo`: o ATALAIA Campo, para o celular do técnico (ADR 0038) — leve, sem o MapLibre;
 * - o resto: a estação de trabalho — o shell RBX (ADR 0047), que abre o cockpit da pessoa (/c/<id>).
 * Cada uma é carregada sob demanda, para o celular não baixar o mapa inteiro em 4G.
 */
import { sessaoAtual } from './sessao.ts';
import { marcarAmbiente } from './ambiente.ts';

/* ADR 0048: a faixa de demonstração vem antes de qualquer tela (pelo build); a sessão confirma (pelo servidor). */
marcarAmbiente();

const raiz = document.getElementById('raiz');
if (!raiz) throw new Error('Elemento #raiz ausente no index.html.');

const campo = location.pathname === '/campo' || location.pathname.startsWith('/campo/');
/* ADR 0041: primeiro acesso e recuperação não dependem de sessão; "minha conta" exige. */
const acesso = location.pathname === '/ativar' ? 'ativar' : location.pathname === '/recuperar' ? 'recuperar' : null;
/* ADR 0051: o atendimento por link é do CLIENTE — sem sessão, sem o ATALAIA, uma página leve e instalável. */
const cliente = location.pathname === '/atendimento' || location.pathname.startsWith('/atendimento/');

/* ADR 0039: sem sessão, a entrada (autenticação normal do ATALAIA); com sessão, a aplicação. */
if (cliente) void import('./atendimento/ClienteAtendimento.tsx').then(({ montarClienteAtendimento }) => montarClienteAtendimento(raiz));
else if (acesso) void import('./Acesso.tsx').then(({ montarAcesso }) => montarAcesso(raiz, acesso));
else void sessaoAtual().then(
  (sessao) => {
    marcarAmbiente(sessao?.tenantNatureza ?? null);
    if (!sessao) return import('./Entrada.tsx').then(({ montarEntrada }) => montarEntrada(raiz, campo));
    if (location.pathname === '/conta') return import('./Acesso.tsx').then(({ montarAcesso }) => montarAcesso(raiz, 'conta'));
    return campo
      ? import('./campo/AppCampo.tsx').then(({ montarCampo }) => montarCampo(raiz))
      : import('./principal.tsx').then(({ montarPrincipal }) => montarPrincipal(raiz, sessao));
  },
  (erro: Error) => { raiz.textContent = `ATALAIA: ${erro.message}`; },
);
